import { useMutation } from '@tanstack/react-query';

import { registerStart } from '../api';

export default function useRegisterStart() {
  return useMutation((data: string) => registerStart(data));
}
